import React, { useEffect, useRef, useState } from "react";

const HOTKEYS = [
  { key: "?", label: "Show keyboard help" },
  { key: "←/→", label: "Navigate questions" },
  { key: "Space", label: "Reveal answer / Next" },
  { key: "L", label: "Lock responses" },
  { key: "R", label: "Show results" },
  { key: "T", label: "Start/stop timer" },
  { key: "Esc", label: "Close overlays" },
];

export default function KeyboardHelpOverlay() {
  const [visible, setVisible] = useState(false);
  const fadeTimeout = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "?" && !visible) {
        setVisible(true);
        if (fadeTimeout.current) clearTimeout(fadeTimeout.current);
        fadeTimeout.current = setTimeout(() => setVisible(false), 6000);
      } else if (visible) {
        setVisible(false);
      }
    };
    const onClick = () => visible && setVisible(false);
    window.addEventListener("keydown", onKeyDown);
    window.addEventListener("mousedown", onClick);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
      window.removeEventListener("mousedown", onClick);
      if (fadeTimeout.current) clearTimeout(fadeTimeout.current);
    };
  }, [visible]);

  if (!visible) return null;
  return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(30,41,59,0.72)",
      zIndex: 9999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      animation: "fadein 0.2s"
    }}>
      <div style={{
        background: "#fff",
        borderRadius: 12,
        boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
        padding: 32,
        minWidth: 320,
        maxWidth: 400,
        textAlign: "left"
      }}>
        <h2 style={{marginTop:0,marginBottom:12,fontSize:20,color:'#1e293b'}}>⌨️ Keyboard Shortcuts</h2>
        <ul style={{listStyle:'none',padding:0,margin:0}}>
          {HOTKEYS.map(h => (
            <li key={h.key} style={{display:'flex',alignItems:'center',marginBottom:8}}>
              <span style={{
                display:'inline-block',
                minWidth:36,
                fontWeight:600,
                color:'#4f46e5',
                fontFamily:'monospace',
                fontSize:16
              }}>{h.key}</span>
              <span style={{marginLeft:12,color:'#334155',fontSize:15}}>{h.label}</span>
            </li>
          ))}
        </ul>
        <div style={{fontSize:12,color:'#64748b',marginTop:16}}>Press any key or click to close</div>
      </div>
    </div>
  );
}
